import { render, staticRenderFns } from "./CategoriesMenu.vue?vue&type=template&id=e4a7a020"
import script from "./CategoriesMenu.vue?vue&type=script&lang=js"
export * from "./CategoriesMenu.vue?vue&type=script&lang=js"
import style0 from "./CategoriesMenu.vue?vue&type=style&index=0&id=e4a7a020&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports